import { render } from "./StageGoalsAndBudget.vue?vue&type=template&id=59655104"
import script from "./StageGoalsAndBudget.vue?vue&type=script&lang=js"
export * from "./StageGoalsAndBudget.vue?vue&type=script&lang=js"

import "./StageGoalsAndBudget.vue?vue&type=style&index=0&id=59655104&lang=scss&scope=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__